import { render, staticRenderFns } from "./geothermal.vue?vue&type=template&id=4e415624&scoped=true&"
var script = {}
import style0 from "./geothermal.vue?vue&type=style&index=0&id=4e415624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e415624",
  null
  
)

export default component.exports